<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>Submit a report</b-card-title>
    </b-card-header>
    <b-card-body>
      <b-card-text>
        You can report the participants who violated the rules during the
        competition.
      </b-card-text>
      <b-card-text>
        You have <span class="text-info font-weight-bolder">12 hours</span> left to report any
        suspicious behavior.
      </b-card-text>
    </b-card-body>
    <div class="w-100 d-flex justify-content-end pb-1 px-1">
      <b-button variant="danger" class="px-2 py-50" @click="$emit('showReportModal')">report</b-button>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BCardText,
  BButton,
} from "bootstrap-vue";
export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BCardText,
    BButton,
  },
};
</script>

<style></style>
